<script>
import { mapConfig } from '@/webtrekk_tracking/config'

export default {
  methods: {
    trackEvent (el, wtConfig) {
      const config = mapConfig(wtConfig)
      EventBus.trigger('tracking:vueEventTrack', { el, config })
    }
  }
}
</script>
